import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appSort',
})
export class SortPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (value === null || typeof value === 'undefined') {
      return [];
    }
    const [direction] = args;
    const order = direction === 'desc' ? -1 : 1;
    // Same result as lodash `orderBy(value, a => a, direction)`: objects sort by their values,
    // null/undefined/NaN go last ascending (first descending). Native so lodash stays out of the initial bundle.
    const items: any[] = Array.isArray(value) ? [...value] : Object.values(value);
    const isEmpty = (v: any): boolean => v === null || v === undefined || v !== v;

    return items.sort((a, b) => {
      if (isEmpty(a) || isEmpty(b)) {
        return (Number(isEmpty(a)) - Number(isEmpty(b))) * order;
      }
      return (a > b ? 1 : a < b ? -1 : 0) * order;
    });
  }
}
